export default function GetParsedDate({ strDate, withTime }) {
  var date = new Date(strDate);

  // Get date components
  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  var day = String(date.getDate()).padStart(2, "0");

  var formattedDate = `${year}-${month}-${day}`;

  if (withTime) {
    var options = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false, // Use 24-hour format
      timeZone: "Asia/Jerusalem", // Specify the desired timezone
    };
    var timeString = date.toLocaleTimeString("en-US", options);
    formattedDate += ` ${timeString}`;
  }

  return formattedDate;
}
